import { defineCustomElement } from 'vue'
import i18n from './infrastructure/i18n.ts';
import Konfigurator from './Konfigurator.vue'

import iwayStyles from './styles.iway.css?inline'

const GfoKonfigurator = defineCustomElement(Konfigurator, {
  configureApp(app) {
    app.use(i18n)
  },
  styles: [iwayStyles],
})

customElements.define('gfo-konfigurator', GfoKonfigurator)
